import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import RichTable from '../components/richTable/RichTable'
import { createDateSorter } from '../components/richTable/sorters'
import tableHelpers from '../helpers/TableHelpers.js'
import EditTrade from './EditTrade.js';
import AlgoStatsTooltip from '../components/AlgoStatsTooltip.js'
import { Chart } from "react-google-charts";
import AlgoDrawer from '../algos/AlgoDrawer.js'
import StockQuickLookDrawer from '../stock/StockQuickLookDrawer.js'
import TradeDetailsDrawer from '../trades/TradeDetailsDrawer.js'

function CompletedBonusTrades(props) {
    const [data, setData] = useState([]);
    const [isEditingTrade, setIsEditingTrade] = useState(false);
    const [editTrade, setEditTrade] = useState(null)
    const [updates, setUpdates] = useState(0);

    function getStats(trades) {
        let stats = { count: 0, winners: 0, losers: 0, avgProfit: 0.0, avgWin: 0.0, avgLoss: 0.0, maxWin: 0.0, maxLoss: 0.0, netProfit: 0.0, avgNetProfit: 0.0, totalProfit: 0.0, totalAlgoProfit: 0.0 }

        trades.forEach(trade => {
            let profit = trade.user_profit;
            stats.totalProfit += profit;
            stats.totalAlgoProfit += trade.algoProfit;
            stats.avgProfit = ((stats.avgProfit * stats.count) + profit) / (stats.count + 1);

            if (profit > 0) {
                if (profit > stats.maxWin) stats.maxWin = profit;
                stats.avgWin = ((stats.avgWin * stats.winners) + profit) / (stats.winners + 1);
                ++stats.winners;
            } else {
                if (profit < stats.maxLoss) stats.maxLoss = profit;
                stats.avgLoss = ((stats.avgLoss * stats.losers) + profit) / (stats.losers + 1);
                ++stats.losers;
            }
            ++stats.count;
        });
        stats.winningPct = (stats.winners / (stats.winners + stats.losers) * 100);
        stats.avgNetProfit = stats.count ? stats.netProfit / stats.count : 0;
        return stats;
    }

    useEffect(() => {
        (async function () {
            let text = "";
            if (props.planId !== undefined) {
                let path = `/api/completedUserTrades/?planId=` + props.planId +
                    "&userId=" + props.userId +
                    "&accountId=" + props.accountId;
                text = await (await fetch(path)).json();
                console.log("completed trades", text);
                setData(text);
            }
        })();
    }, [props.planId, props.userId, props.accountId, updates, props.updates]);

    function getTrades() {
        return data.map(trade => {
            let userProfit = trade.user_sell_price ? trade.user_sell_price - trade.purchase_price : trade.sell_price - trade.purchase_price
            userProfit = userProfit * trade.user_amount
            let algoProfit = trade.sell_price ? (trade.sell_price - trade.purchase_price) * trade.user_amount : (trade.current_price - trade.purchase_price) * trade.user_amount
            return {
                idplan_trades: trade.idplan_trades,
                trade_symbol: trade.trade_symbol,
                base_symbol: trade.symbol,
                purchase_date: trade.purchase_date,
                purchase_price: trade.user_purchase_price ? trade.user_purchase_price : trade.purchase_price,
                sell_date: trade.user_sell_date ? trade.user_sell_date : trade.sell_date,
                sell_price: trade.user_sell_price ? trade.user_sell_price : trade.sell_price,
                dollarProfit: userProfit,
                profit: userProfit,
                algoProfit: algoProfit,
                isAlgoClosed: trade.sell_price > 0,
                display_name: trade.display_name,
                algo_type: trade.algo_type,
                entry_speed: trade.entry_speed,
                algoId: trade.idalgos,
                allocation: trade.allocation,
                avg_win: trade.avg_win,
                avg_loss: trade.avg_loss,
                realizedProfit: userProfit,
                user_symbol: trade.user_symbol,
                user_amount: trade.user_amount,
                user_trade_id: trade.user_trade_id,
                user_purchase_price: trade.user_purchase_price,
                user_sell_price: trade.user_sell_price,
                user_profit: userProfit,
                user_trade_is_option: trade.user_trade_is_option,
                short: trade.short,
            }
        })
    }

    function getStatsArray() {
        let stats = getStats(getTrades());
        return [stats];
    }

    function getChartDataStats(chartData) {
        let min = null;
        let max = null;
        for (let i = 1; i < chartData.length; ++i) {
            let val = chartData[i][2];
            if (min === null || val < min) min = val;
            if (max === null || val > max) max = val;
        }
        return { min: min, max: max };
    }

    function getChartData() {

        let ret = [["Date", "Profit", "Running Total"]];
        let runningTotal = 0.0;

        let trades = getTrades().sort((a, b) => new Date(a.sell_date) - new Date(b.sell_date));
        trades.forEach(trade => {
            let date = tableHelpers.dateFormmatter(trade.sell_date);
            let profit = trade.user_profit;
            runningTotal += profit;
            ret.push([date, profit, runningTotal]);
        });
        return ret;
    }

    function getCalendarData() {
        let data = [];
        let trades = getTrades();

        const uniqueYears = [...new Set(trades.map(trade => new Date(trade.sell_date).getFullYear()))];
        uniqueYears.forEach(year => {
            let yearData = { year: year, january: 0.0, february: 0.0, march: 0.0, april: 0.0, may: 0.0, june: 0.0, july: 0.0, august: 0.0, september: 0.0, october: 0.0, november: 0.0, december: 0.0, total: 0.0 };

            trades.filter(trade => new Date(trade.sell_date).getFullYear() === year)
                .forEach(trade => {
                    let month = new Date(trade.sell_date).getMonth();
                    let profit = trade.user_profit;
                    yearData.total += profit;
                    switch (month) {
                        case 0:
                            yearData.january += profit;
                            break;
                        case 1:
                            yearData.february += profit;
                            break;
                        case 2:
                            yearData.march += profit;
                            break;
                        case 3:
                            yearData.april += profit;
                            break;
                        case 4:
                            yearData.may += profit;
                            break;
                        case 5:
                            yearData.june += profit;
                            break;
                        case 6:
                            yearData.july += profit;
                            break;
                        case 7:
                            yearData.august += profit;
                            break;
                        case 8:
                            yearData.september += profit;
                            break;
                        case 9:
                            yearData.october += profit;
                            break;
                        case 10:
                            yearData.november += profit;
                            break;
                        case 11:
                            yearData.december += profit;
                            break;
                        default:
                            break;
                    }
                });
            data.push(yearData);
        });

        return data;
    }

    function algoLinkFormatter(cell, row) {

        let algoid = row.algoId;
        return (<div class='sameline'>
            <AlgoDrawer link={cell} planId={props.planId} accountId={props.accountId} userId={props.userId} mobileView={props.mobileView} algoId={algoid} role={props.role} />
            &nbsp;<AlgoStatsTooltip algoId={algoid} years={0} />
        </div>
        )
    }

    function symbolAlgoFormatter(cell, row) {
        let algoid = row.algoId;
        return (
            <div class='sameline'>
                <StockQuickLookDrawer planId={props.planId} accountId={props.accountId} userId={props.userId} mobileView={props.mobileView} symbol={cell} role={props.role} /> <AlgoDrawer link={row.display_name} planId={props.planId} accountId={props.accountId} userId={props.userId} mobileView={props.mobileView} algoId={algoid} role={props.role} />
                {row.user_symbol ?
                    <>&nbsp;<Link className="bg-transparent" to={"/algo/" + algoid}>{row.display_name}</Link>  <Link className="bg-transparent" onClick={() => showEditModal(row)}>✏️</Link>
                    </>
                    : null}
                &nbsp;<AlgoStatsTooltip algoId={algoid} years={0} />
            </div>
        )
    }

    function algoProfitFormatter(cell, row) {
        return <>
            {tableHelpers.moneyChangeFormatterNoCents(cell)} {row.isAlgoClosed ? null : "*"}
        </>
    }

    function sharesFormatter(cell, row) {
        return <>
            {tableHelpers.intFormatter(cell)} <Link className="bg-transparent" onClick={() => showEditModal(row)}>✏️</Link>
        </>
    }

    function showEditModal(trade) {
        console.log("Opening modal for ", trade);
        setIsEditingTrade(true);
        setEditTrade(trade)
    }

    function onStopEditingTrade() {
        setIsEditingTrade(false)
        setEditTrade(null);
        setUpdates(updates + 1);

        if (props.onUpdate) props.onUpdate();
    }



    function sellDateFormatter(cell, row) {
        return (
            <>
                <TradeDetailsDrawer userId={props.userId} mobileView={props.mobileView} planTradeId={row.idplan_trades} link={tableHelpers.dateFormmatter(cell, row)} />
            </>
        )
    }

    let chartData = getChartData();
    let stats = getChartDataStats(chartData);
    let now = new Date();

    return (
        <>
            <RichTable data={getStatsArray()} className="table-striped table-hover table-condensed fixed" mappers={[
                { title: 'Trades', field: 'count', formatter: tableHelpers.intFormatter },
                { title: 'Win %', field: 'winningPct', formatter: tableHelpers.percentFormatter },
                { title: 'Net', field: 'totalProfit', formatter: tableHelpers.moneyChangeFormatterNoCents },
                { title: 'Algo Net', field: 'totalAlgoProfit', formatter: tableHelpers.moneyChangeFormatterNoCents },
                { title: 'Avg P/L', field: 'avgProfit', formatter: tableHelpers.moneyChangeFormatterNoCents },
                { title: 'Avg Win', field: 'avgWin', formatter: tableHelpers.moneyChangeFormatterNoCents, hidden: props.mobileView },
                { title: 'Avg Loss', field: 'avgLoss', formatter: tableHelpers.moneyChangeFormatterNoCents, hidden: props.mobileView },
            ]} />

            <RichTable data={getCalendarData()} className="table-striped table-hover table-condensed" mappers={[
                { title: 'Year', field: 'year', formatter: tableHelpers.intFormatter, sorters: false },
                { title: 'Jan', field: 'january', formatter: tableHelpers.moneyChangeFormatterNoCents, sorters: false, hidden: props.mobileView && now.getMonth() !== 0 },
                { title: `Feb`, field: 'february', sorters: false, formatter: tableHelpers.moneyChangeFormatterNoCents, hidden: props.mobileView && now.getMonth() !== 1 },
                { title: 'Mar', field: 'march', formatter: tableHelpers.moneyChangeFormatterNoCents, sorters: false, hidden: props.mobileView && now.getMonth() !== 2 },
                { title: 'Apr', field: 'april', formatter: tableHelpers.moneyChangeFormatterNoCents, sorters: false, hidden: props.mobileView && now.getMonth() !== 3 },
                { title: 'May', field: 'may', formatter: tableHelpers.moneyChangeFormatterNoCents, sorters: false, hidden: props.mobileView && now.getMonth() !== 4 },
                { title: 'Jun', field: 'june', formatter: tableHelpers.moneyChangeFormatterNoCents, sorters: false, hidden: props.mobileView && now.getMonth() !== 5 },
                { title: 'Jul', field: 'july', formatter: tableHelpers.moneyChangeFormatterNoCents, sorters: false, hidden: props.mobileView && now.getMonth() !== 6 },
                { title: 'Aug', field: 'august', formatter: tableHelpers.moneyChangeFormatterNoCents, sorters: false, hidden: props.mobileView && now.getMonth() !== 7 },
                { title: 'Sep', field: 'september', formatter: tableHelpers.moneyChangeFormatterNoCents, sorters: false, hidden: props.mobileView && now.getMonth() !== 8 },
                { title: 'Oct', field: 'october', formatter: tableHelpers.moneyChangeFormatterNoCents, sorters: false, hidden: props.mobileView && now.getMonth() !== 9 },
                { title: 'Nov', field: 'november', formatter: tableHelpers.moneyChangeFormatterNoCents, sorters: false, hidden: props.mobileView && now.getMonth() !== 10 },
                { title: 'Dec', field: 'december', formatter: tableHelpers.moneyChangeFormatterNoCents, sorters: false, hidden: props.mobileView && now.getMonth() !== 11 },
                { title: 'Total', field: 'total', formatter: tableHelpers.moneyChangeFormatterNoCents, sorters: false },
            ]} />

            {chartData.length <= 1 ? null :
                <Chart
                    chartType="ComboChart"
                    data={chartData}
                    width={"100%"}
                    height={"400px"}
                    chartPackages={["corechart", "controls"]}
                    options={{
                        legend: 'none',
                        seriesType: "bars",
                        series: {
                            1: { type: "line" },
                        },
                        vAxis: {
                            viewWindow: {
                                max: stats.max,
                                min: stats.min
                            }
                        }
                    }}
                />}

            <hr></hr>

            {props.mobileView ?
                <RichTable data={getTrades()} className="table-striped table-hover table-condensed" pageSize={10} mappers={[
                    { title: 'Sell Date', field: 'sell_date', formatter: tableHelpers.dateFormmatter, sorters: createDateSorter('sell_date'), isDefaultSort: true },
                    { title: 'Shares', field: 'user_amount', formatter: sharesFormatter, sorters: true },
                    { title: `Algo`, field: 'trade_symbol', sorters: true, formatter: symbolAlgoFormatter },
                    { title: 'P/L', field: 'user_profit', formatter: tableHelpers.moneyChangeFormatterNoCents, sorters: true },
                ]} />
                :
                <RichTable data={getTrades()} className="table-striped table-hover table-condensed" pageSize={10} mappers={[
                    { title: 'Purch Date', field: 'purchase_date', formatter: tableHelpers.dateFormmatter, sorters: createDateSorter('purchase_date') },
                    { title: 'Sell Date', field: 'sell_date', formatter: sellDateFormatter, sorters: createDateSorter('sell_date'), isDefaultSort: true },
                    { title: 'Shares', field: 'user_amount', formatter: sharesFormatter, sorters: true },
                    { title: 'Symbol', field: 'trade_symbol', sorters: true },
                    { title: 'Algo', field: 'display_name', formatter: algoLinkFormatter, sorters: true },
                    { title: 'P/L', field: 'user_profit', formatter: tableHelpers.moneyChangeFormatterNoCents, sorters: true },
                    { title: 'Algo P/L', field: 'algoProfit', formatter: algoProfitFormatter, sorters: true },
                ]} />
            }
            * = Algo still open

            <br></br>
            <EditTrade isOpen={isEditingTrade && editTrade}
                onClose={onStopEditingTrade}
                userTradeId={editTrade ? editTrade.user_trade_id : null}
            />
        </>
    );
}

export default CompletedBonusTrades;